import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-client_id", "data-login_uri"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "g_id_signin",
  "data-type": "standard",
  "data-size": "large",
  "data-theme": "outline",
  "data-text": "sign_in_with",
  "data-shape": "rectangular",
  "data-logo_alignment": "left"
}, null, -1);
import { onBeforeMount } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleAuth',
  setup(__props) {
    const {
      GAUTH_CLID,
      GAUTH_REDIRECT
    } = process.env;
    onBeforeMount(() => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      document.body.appendChild(script);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        id: "g_id_onload",
        "data-client_id": _unref(GAUTH_CLID),
        "data-login_uri": _unref(GAUTH_REDIRECT),
        "data-context": "signin",
        "data-itp_support": "true"
      }, null, 8, _hoisted_1), _hoisted_2]);
    };
  }
});